import React from 'react';
import { connect } from 'react-redux';

import { Nav, NavItem, NavLink } from 'reactstrap';
import { initCalculateTab } from '@reducers/web-services/calculate/actions';
import { initMaterialTab, setSpinner as setMaterialSpinner } from '@reducers/web-services/material/actions';

import classnames from 'classnames';
import { 
  hide3DDimensions,
  hideLoads, 
  // show3DDimensions, 
  showLoads 
} from '@reducers/options/actions';

import { APP_TEXTS } from '../../texts/texts';
import { APP_STATES } from '@config';
import { callErrorNotification } from '@components/Notification';
// import { EventManager, EVENTS } from '@components/Events/events';
import ObjectView from '@scene/views/object-view';


/* eslint-disable */
const Navigation = props => (
  <Nav tabs>
    { props.isEditor ? (
      <React.Fragment>
        <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === props.tabs.PLATE })}
              onClick={() => {
                props.toggle(props.tabs.PLATE, props.appStatus);
              }}
            >
             {APP_TEXTS.LABEL_NAV_PLATE.Content}
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink
              className={classnames({ active: props.activeTab === props.tabs.ANCHORS })}
              onClick={() => {
                props.toggle(props.tabs.ANCHORS, props.appStatus);
              }}
            >
             {APP_TEXTS.LABEL_NAV_ANCHORS.Content}
            </NavLink>
        </NavItem>
      </React.Fragment>
    ) : (
      <React.Fragment>
        {/* {(props.appStatus === APP_STATES.NOT_INITIALIZED || props.appStatus === APP_STATES.REVIEW_OPTIONS) && ( */}
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.OPTIONS })}
            onClick={() => {
              props.toggle(props.tabs.OPTIONS, props.appStatus);
            }}
          >
            {APP_TEXTS.OPTIONS.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.APPLICATION })}
            onClick={() => {
              props.toggle(props.tabs.APPLICATION, props.appStatus);
            }}
          >
            {APP_TEXTS.APPLICATIONS.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.DIMENSION })}
            onClick={() => {
              props.toggle(props.tabs.DIMENSION, props.appStatus);
            }}
          >
            {APP_TEXTS.DIMENSIONS.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.MATERIAL })}
            onClick={() => {
              props.toggle(props.tabs.MATERIAL, props.appStatus);
              props.initMaterialTab();
            }}
          >
          {APP_TEXTS.NAV_MATERIAL.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.LOADS })}
            onClick={() => {
              props.toggle(props.tabs.LOADS, props.appStatus);
            }}
          >
          {APP_TEXTS.NAV_LOADS.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.DESIGN })}
            onClick={() => {
              props.toggle(props.tabs.DESIGN, props.appStatus);
            }}
          >
          {APP_TEXTS.NAV_DESIGN.Content}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: props.activeTab === props.tabs.CALCULATE })}
            onClick={() => {
              if (props.activeTab != props.tabs.CALCULATE || props.allowCalculation) {
                if (props.toggle(props.tabs.CALCULATE, props.appStatus))
                  props.initCalculateTab();
              }
            }}
          >
            {APP_TEXTS.NAV_CALCULATE.Content}
          </NavLink>
        </NavItem> 
      </React.Fragment>
    )}
    {/* {props.tabs.map(i => 
      (i.key != tabs.OPTIONS || (props.appStatus === APP_STATES.NOT_INITIALIZED || props.appStatus === APP_STATES.REVIEW_OPTIONS)) && (
        <NavItem key={i.key}>
          <NavLink
            className={classnames({ active: props.activeTab === i.key })}
            onClick={() => {
              props.toggle(i.key);
            }}
          >
            {i.value}
          </NavLink>
        </NavItem>
      ))} */}
  </Nav>
);

const mapDispatch = (dispatch, ownProps) => ({
  initCalculateTab: async () => {
    await dispatch(initCalculateTab());
  },
  initMaterialTab: async () => {
    dispatch(setMaterialSpinner(true));
    await dispatch(initMaterialTab());
    dispatch(setMaterialSpinner(false));
  },
  toggle: (tab, appStatus) => {
    if (appStatus === APP_STATES.NOT_INITIALIZED){
      callErrorNotification(APP_TEXTS.NOTIFICATIONS_APP_NOT_INITIALIZED.Content);
      return false;
    }

    switch (tab) {
      case ownProps.tabs.OPTIONS: {
        dispatch(hide3DDimensions());
        break;
      }
      case ownProps.tabs.DIMENSION: {
        dispatch(hideLoads());
        // dispatch(show3DDimensions());
        break;
      }
      case ownProps.tabs.APPLICATION:
      case ownProps.tabs.MATERIAL: {
        dispatch(hideLoads());
        // dispatch(hide3DDimensions());

        break;
      }
      case ownProps.tabs.LOADS:
      case ownProps.tabs.DESIGN: {
        dispatch(showLoads());
        // dispatch(hide3DDimensions());

        break;
      }
      case ownProps.tabs.CALCULATE: {
        // TODO: Block calculate tab
        // if (!this.isLoadsValue()) {
        //   alert('Loads must be defined before launching the calculation. Please add loads in the loads tab.');
        //   return;
        // }
        dispatch(showLoads());
        // dispatch(hide3DDimensions());

        break;
      }
      default: {
        break;
      }
    }

    if (ownProps.toggle) {
      ownProps.toggle(tab);
      // EventManager.emit(EVENTS.TAB_SWITCHED, tab);
      return true;
    }
    return false;
  }
});

const mapState = (state) => ({
  appStatus: state.main.status,
  isEditor: state.main.mode === ObjectView.mode.MODE_2D_EDITOR
})

export default connect(mapState, mapDispatch)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Nav/index.js